import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Text, useMantineTheme, Menu, ActionIcon } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

const GaransiSelectedBatalkan = ({ stateData, fnSuccess }) => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitBatalkan: 'garansiSelectedBatalkan-1',
    })

    const [data, setData] = React.useState({
        batalkanGaransiModal: false,
        batalkanGaransiSubmitLoading: false,
        batalkanGaransiGaransiId: '',
        batalkanGaransiDetilId: '',
        batalkanGaransiDetilName: '',
        batalkanGaransiReferensi: '',

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitBatalkanGaransi = () => {
        setData(d => ({ ...d, batalkanGaransiSubmitLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);

        formDT.append('garansi_id', data.batalkanGaransiGaransiId);
        formDT.append('garansi_detil_id', data.batalkanGaransiDetilId);
        formDT.append('garansi_referensi', data.batalkanGaransiReferensi);
        formDT.append('garansi_item_status', utils.statusItemGaransi.pengajuan_klaim_garansi.value);
        formDT.append('flag_referensi_pengerjaan', utils.garansiReference.project_pengerjaan.value);
        formDT.append('flag_referensi_history', utils.garansiReference.project_pengerjaan_history.value);
        formDT.append('flag_referensi_tambahan_stok', utils.garansiReference.project_tambahan_stock.value);
        formDT.append('flag_referensi_master_stok', utils.garansiReference.master_stock.value);

        formDT.append('flag_status_stock_obj', JSON.stringify(utils.stockItemStatus));

        axios({
            method: 'post',
            url: BE_API_THREE + '/batalkan_klaim_garansi',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, batalkanGaransiSubmitLoading: false, batalkanGaransiModal: false }));

            if (response.data.flag_status === 'isset') {
                fnSuccess();
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitBatalkan,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan !',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'duplicate-serial-number') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: `Serial number ${response.data.suspect} sudah pernah didaftarkan pada sub kategori ${response.data.data_1}`,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, batalkanGaransiSubmitLoading: false, batalkanGaransiModal: false }));

            notifications.show({
                id: notificationId.current.errorSubmitBatalkan,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        })
    }

    return (
        <React.Fragment>
            <Menu
                shadow="md"
                position='bottom-end'
            >
                <Menu.Target>
                    <ActionIcon
                        size='md'
                        variant="subtle"
                        radius='xl'

                        sx={{
                            backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[5]
                        }}
                    >
                        <IconDotsVertical size='1rem' />
                    </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                    {stateData.referensi === utils.garansiReference.project_pengerjaan_history.value ?
                        <Menu.Item
                            onClick={() => {
                                setData(d => ({
                                    ...d,
                                    batalkanGaransiGaransiId: stateData.data.stock_garansi_id,
                                    batalkanGaransiDetilId: stateData.data.stock_garansi_detil_id,
                                    batalkanGaransiDetilName: stateData.name,
                                    batalkanGaransiReferensi: stateData.referensi,
                                    batalkanGaransiModal: true
                                }))
                            }}
                        >
                            Batalkan Klaim Garansi
                        </Menu.Item>
                        :
                        <Menu.Item
                            onClick={() => {
                                setData(d => ({
                                    ...d,
                                    batalkanGaransiGaransiId: stateData.data.stock_garansi_id,
                                    batalkanGaransiDetilId: stateData.data.stock_garansi_detil_id,
                                    batalkanGaransiDetilName: stateData.name,
                                    batalkanGaransiReferensi: stateData.referensi,
                                    batalkanGaransiModal: true
                                }))
                            }}
                        >
                            Batalkan Klaim Garansi
                        </Menu.Item>
                    }
                </Menu.Dropdown>
            </Menu>

            <ModalTakeAction
                stateShow={data.batalkanGaransiModal}
                fnHide={() => setData(d => ({ ...d, batalkanGaransiModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.batalkanGaransiSubmitLoading}
                fnButtonAction={submitBatalkanGaransi}
            >
                <Text size='sm'>
                    Batalkan klaim garansi {data.batalkanGaransiDetilName} ?
                </Text>
            </ModalTakeAction>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default GaransiSelectedBatalkan;